var squizSearchPage = (function () {
    // Populate the search summary in the page banner.
    function updateBanner() {
        $('.js-search-results-banner').text($('.js-search-results-summary').text());
    }

    function activateMoreResults() {
        var DEBUG = 0;

        if($('.search__more-button').length) {
            var $searchButton = $('.search__more-button'),
                $searchList = $searchButton.siblings('.search__list');

            $searchButton.click(function() {
                if(!$searchButton.hasClass('disabled')) {
                    $searchButton.addClass('disabled');
                    $.ajax($searchButton.attr('href'))
                        .done(function(page) {
                            if(DEBUG) {
                                console.log(page);
                            }

                            var $page = $(page),
                                $newList = $page.find('.search__list'),
                                $newLink = $page.find('.search__more-button');
                                
                            if($newList.length) {
                                $searchList.append($newList.html());
                            }

                            if($newLink.length) {
                                $searchButton.attr('href', $newLink.attr('href')).removeClass('disabled');
                            } else {
                                $searchButton.remove();
                            }
                            
                        })
                        .fail(function(jqXHR, textStatus) {
                            if(DEBUG) {
                                console.log('Search fail: ' + textStatus);
                                $searchButton.removeClass('disabled');
                            } else {
                                window.location.href = $searchButton.attr('url');
                            }
                        });
                }

                return false;
            });
        }
    }

    const copyLinkToClipboard = function() {

        $(document).on('click', '.js-copy-link', function(e) {
          if (e.preventDefault) { 
            e.preventDefault(); 
          } else { 
            e.returnValue = false; 
          }
          //e.preventDefault();
          e.preventDefault();
          const el = document.createElement('textarea');
          el.value = $(this).attr('href');
          el.setAttribute('readonly', '');
          el.style.position = 'fixed';
          el.style.left = '-9999px';
    
          document
            .body
            .appendChild(el);
          el.select();
          document.execCommand('copy');
          document
            .body
            .removeChild(el);
    
          var linkElem = $(this);
          var tagContent = $(this).html();
          linkElem.html(function(id, tagContent) {
            if ($(window).width() > 600) {
              return tagContent.replace(/Copy link/, 'Copied!');
            } else  {
              $(this).addClass('mb-display');
              return tagContent.replace(/Copy link/, 'Copied!');       
            }
            
          });
    
          setTimeout(function() {
            linkElem
              .html(function(id, tagContent) {
                if( tagContent.indexOf('clipboard') > -1) {
                  return tagContent.replace(/Copied!/, 'Copy link');
                } else {
                  $(this).removeClass('mb-display');
                  return tagContent.replace(/Copied!/, 'Copy link');
                }
                
              });
    
          }, 1500);
    
        });
    
      }
    /**
     * Initialisation
     */
    return {
         init: function() {
            updateBanner();
            activateMoreResults();
            copyLinkToClipboard();
        }
    }
})();

(function() {
    squizSearchPage.init();
}(jQuery));